import { BookmakerIcon } from "../icons";
import config from "./config";
import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

export const bookmakersConfig = config;

export default {
	options: {
		group: "bookmakers",
		roles: ["admin", "affiliate_manager"],
	},
	icon: BookmakerIcon,
	list: List,
	edit: Edit,
	create: Create,
};
